module.exports = __webpack_public_path__ + "static/media/star7.386e9463.svg";